import API from '.';
export default {
    getGroupList: (params) => {
        return API.get('/tasks/groups/list', {
            params
        });
    },
    create: (params) => {
        return API.post(`/tasks/groups/add`, params)
    },
    setGroup: (params) => {
        return API.put(`/tasks/groups/set_task`, params)
    },

    getZoneList: (params) => {
        return API.get('/tasks/zones', {
            params
        });
    },

}